module.exports = __webpack_public_path__ + "img/icon-login-pro.2203f018.svg";